import React, {
    useMemo,
    useState,
} from 'react';

import avatar from 'assets/images/avatar.svg';

import { AppBar, Avatar, Box, Button, Card, CardContent, Fade, Grid, Popover, Typography, useTheme } from '@mui/material';
import { useAuth } from 'services/auth';
import { useNavigate } from 'react-router-dom';
import HeaderIcons from './HeaderIcons';
import { useCompany } from 'services/company';

import fullLogo from 'assets/images/logo_full.svg';

const UserDetails = function () {
    const auth = useAuth();
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setIsOpen(!isOpen);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setIsOpen(!isOpen);
    };
    const id = isOpen ? 'userDetails-popover' : undefined;

    return (
        <Box display='flex' alignItems={'center'} gap={2}>
            <Grid
                container
                spacing={2}
                direction='row'
                alignItems='center'
                justifyContent='space-between'
                onClick={handleClick}
            >
                <Grid item>
                    <Typography
                        variant={'subtitle2'}
                        alignItems={'center'}
                    >
                        {`${auth.firstName} ${auth.lastName}`}
                    </Typography>
                </Grid>
                <Grid item>
                    <Avatar src={avatar}></Avatar>
                </Grid>
            </Grid>
            <Popover
                id={id}
                open={isOpen}
                anchorEl={anchorEl}
                onClose={handleClose}
                PaperProps={{ sx: { borderRadius: '16px', boxShadow: '0px 12px 32px -8px rgba(42, 42, 42, 0.24)' } }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <Fade in={isOpen}>
                    <Card>
                        <CardContent>
                            <Button
                                type='button'
                                color='secondary'
                                variant='contained'
                                onClick={() => {
                                    auth.actions.logout();
                                    navigate('/login');
                                }}
                                sx={{
                                    borderRadius: '100px',
                                    padding: '8px 40px',
                                    fontFamily: ['Source Sans Pro', 'sans-serif'].join(','),
                                    fontWeight: '600',
                                    fontSize: '14px',
                                }}
                            >
                                logout
                            </Button>
                        </CardContent>
                    </Card>
                </Fade>
            </Popover>
        </Box>
    );
};

const Header = () => {
    const theme = useTheme();
    const companyContext = useCompany();
    const companyName = companyContext?.state?.company?.name;
    const logo = useMemo(() => {
        // TODO: dark mode support
        return theme.palette.mode === 'dark'
            ? fullLogo
            : fullLogo;
    }, [theme.palette.mode]);
    return (
        <>
            <AppBar position='fixed'>
                <Box display='flex' justifyContent='space-between' p='10px 40px' alignItems='center'>
                    <Box flex={1} display='flex' alignItems='center' gap={2}>
                        <img alt='Repair Exchange' style={{
                            maxWidth: 200,
                            height: 'auto',
                            padding: '4px',
                        }} src={logo} />
                        {companyName && (
                            <Typography variant='subtitle1' noWrap color='text.primary'>
                                {companyName}
                            </Typography>
                        )}
                    </Box>
                    <Box flex={1}>
                        {/* <AppSearch /> */}
                    </Box>
                    <Box flex={1} sx={{ display: 'flex', justifyContent: 'end' }}>
                        <HeaderIcons />
                    </Box>
                </Box>
            </AppBar>
        </>
    );
};

Header.propTypes = {

};

export default Header;